"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminOnboardingsApiV1 = void 0;
const createApi_1 = require("../../helpers/createApi");
const get = (caller) => ({ accountId: account_id, taskLabel: task_label, ...otherParams }) => {
    return caller(`/accounts/${account_id}/admin-onboardings/${task_label}`).get({
        ...otherParams,
    });
};
exports.adminOnboardingsApiV1 = (0, createApi_1.createAPIFactory)({
    get,
});
//# sourceMappingURL=api.js.map